const breakPoint = 767;
let resizeFlag   = false;
let windowWidth  = window.innerWidth;
let windowHeight = window.innerHeight;
let windowWidthJ = $(window).width();

function videoControl(action, target) {
  var $playerWindow = $(target)[0].contentWindow;
  $playerWindow.postMessage('{"event":"command","func":"' + action + '","args":""}', '*');
}


const preload = () => {
  $(window).on("load", function () {
    $("body").css("opacity","");
  });
};


// ------------------------------------------------------------------------
// anchorLink
// ----- BOTH
// ------------------------------------------------------------------------
const anchorLink = () => {
  $("a[href^='#']").on("click", function(){
    var linkSpeed    = 800;
    var linkHref     = $(this).attr("href");
    var linkTarget   = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
    var linkAdjust   = 0;
    var linkPosition = linkTarget.offset().top;
    $("html, body").animate({scrollTop: linkPosition - linkAdjust}, linkSpeed, "swing");
    return false;
  });
};


// ------------------------------------------------------------------------
// toggleMenu
// ------------------------------------------------------------------------
const toggleMenu = () => {
  $('.header-hamburger').on('click', function() {
    if($(this).hasClass("movie")){
      $(".st-Movie").removeClass("open");
      $(".header-hamburger button").removeClass("open");
      $(".header-hamburger").removeClass("open").removeClass("movie");
      $('#youtube-modal').attr("src", "");
    } else {
      $(this).toggleClass("open");
      $(".header-nav").toggleClass("open");
    }
  });
};

// ------------------------------------------------------------------------
// imgSlider
// ----- BOTH
// ------------------------------------------------------------------------
const imgSlider = () => {
  if ($('.box-slider').length) {
    $('.box-slider').slick({
      autoplay: true,
      autoplaySpeed: 5000,
      infinite: true,
      slidesToShow: 1,
      dots: true,
      speed: 800,
      slidesToShow: 1,
      centerMode: true,
      focusOnSelect: true,
      variableWidth: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
          }
        },
      ]
    });
  }
};


// ------------------------------------------------------------------------
// toggleMovie
// ------------------------------------------------------------------------
const toggleMovie = () => {
  const ua = navigator.userAgent;
  $(".movie-toggle").on("click", function () {
    let youtubeId = $(this).data("youtube");
    let embedUrl = "https://www.youtube.com/embed/" + youtubeId + "?autoplay=1&mute=1&enablejsapi=1";
    $(".st-Movie").toggleClass("open");
    $(".header-hamburger button").toggleClass("open");
    $(".header-hamburger").toggleClass("open").toggleClass("movie");
    $('#youtube-modal').attr("src", embedUrl);
    $('#youtube-modal').on('load', function () {
      videoControl("playVideo", '#youtube-modal');
      if (/android/i.test(ua)) {
        videoControl("unMute", '#youtube-modal');
      }
    });
  });
};



// ------------------------------------------------------------------------
// animeScroll
// ------------------------------------------------------------------------
const animeScroll = () => {
  $(window).on("load", function () {
    $(".anim-sc").each(function (i, node) {
      gsap.to(node, {
        scrollTrigger: {
          trigger: node,
          start: 'top bottom-=200',
          toggleClass: { targets: node, className: "animated" },
          once: true
        }
      });
    });
  });
};




// ------------------------------------------------------------------------
// animeLoad
// ------------------------------------------------------------------------
const animeLoad = () => {
  $(window).on("load", function () {
    $(".anim-ld").toggleClass("animated");
  });
};



export {
  preload,
  imgSlider,
  anchorLink,
  toggleMenu,
  toggleMovie,
  animeScroll,
  animeLoad
}



// WEBPACK FOOTER //
// ./src/assets/js/include/module.js